'use strict';

var processInclude = require('./components/processInclude');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('./search/compare'));
});
